import React, { useEffect, useState } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import { addProjectDetails } from "../../redux/actions/uiActions";
import { useDispatch, useSelector } from "react-redux";
import { addProject } from "../../redux/actions/web3Actions";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },
}));

const ProjectRegistrationStepThree = ({ onNextClick, changeFlag,setDisableButton }) => {
  const classes = useStyles();

  const [contactName, setContactName] = useState("");
  const [telegramId, setTelegramId] = useState("");

  const projectData = useSelector((state) => state.ui.projectData);

  console.log("ProjectRegistrationStepThree => ", projectData);

  const dispatch = useDispatch();
  useEffect(() => {
    if (contactName && telegramId)
      setDisableButton(false);
  }, [telegramId, contactName]);
  useEffect(() => {
    if (Object.keys(projectData).length > 0) {
      setContactName(projectData.contactName || "");
      setTelegramId(projectData.telegramId || "");
    }
  }, [projectData]);

  useEffect(() => {
    if (changeFlag === 3) {
      console.log("flag clicked 3");
      dispatch(
        addProjectDetails({
          contactName,
          telegramId,
        })
      );

      // dispatch(addProject({ ...projectData, contactName, telegramId }));

      onNextClick();
    }
  }, [changeFlag]);

  return (
    <Box className={classes.container}>
      <Box className={classes.stepHeader}>
        <Typography className={classes.pageHeading}>Step 3</Typography>

        <Typography className={classes.headingDesc}>
          Provide contact details for project founders
        </Typography>
      </Box>

      <Box>
        <InputWithLabel
          label="Contact Name"
          value={contactName}
          setValue={setContactName}
          placeholder="i.e: Sarim Barni"
        />
        <InputWithLabel
          label="Telegram ID"
          value={telegramId}
          setValue={setTelegramId}
          placeholder="i.e: (555) 555-1234"
        />
      </Box>
    </Box>
  );
};

export default ProjectRegistrationStepThree;
